export default class VoucherCategoryDetailsResponse {
    constructor(supportedLocales) {
        this.id = null;
        this.name = undefined;
        this.translations = [];
        supportedLocales?.forEach((element) => {
            this.translations[element] = {
                name: '',
            };
        });
        this.supportedLocales = supportedLocales;
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id;
            to.name = from.name;
            to.supportedLocales?.forEach((element) => {
                to.translations[element] = {
                    name: from.translations[element]?.name,
                };
            });
        } else {
            to = new VoucherCategoryDetailsResponse();
        }
    }

    static copy(to, from) {
        VoucherCategoryDetailsResponse.assign(from, to);
        return to;
    }
}
